import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { AutosizedTextField } from './AutosizedTextField';
const debug = process.env.REACT_APP_DEBUG && false;
/**
 * Naive method of parsing localised number formats in a string
 *
 * https://stackoverflow.com/a/45309230
 *
 * It would be preferable to use a proper i18n library: https://stackoverflow.com/a/55366435
 *
 * @param value string to parse
 * @param locales languages to use for parsing
 * @returns parsed number
 */
function parseNumber(value, locales = navigator.languages) {
    const example = Intl.NumberFormat(locales).format('1.1');
    const cleanPattern = new RegExp(`[^-+0-9e${example.charAt(1)}]`, 'g');
    const cleaned = value.replace(cleanPattern, '');
    const normalized = cleaned.replace(example.charAt(1), '.');
    const parsed = parseFloat(normalized);
    debug && console.log('NumericField', 'parseNumber', example, cleaned, normalized, parsed);
    return parsed;
}
/**
 * A Mui TextField (using an {@link AutosizedTextField}) that parses and handles numeric input only
 *
 * Pass in the default `value` — changes to `value` will override whatever the user entered
 *
 * The `onChange` event provides the parsed `number` — use this to update a `useState` in the parent (but don't pass it back in as the `value`!)
 */
export const NumericField = (props) => {
    const { value, onChange, ...rest } = props;
    const [number, setNumber] = useState(value !== undefined && !Number.isNaN(value) ? (value?.toLocaleString(undefined, { maximumFractionDigits: 20 }) ?? '') : '');
    useEffect(() => {
        /** value?.toLocaleString() rounds fractional digits to 3 decimals by default. Which is not desired eg it makes a 5 decimal Lat Lng (1m precision) to 100m precision */
        setNumber(value !== undefined && !Number.isNaN(value) ? (value?.toLocaleString(undefined, { maximumFractionDigits: 20 }) ?? '') : '');
    }, [value]);
    useEffect(() => {
        const parsedNumber = parseNumber(number);
        const value = isNaN(parsedNumber) ? null : parsedNumber;
        onChange?.(value);
    }, [number]);
    return (_jsx(AutosizedTextField, { value: number, onChange: (event) => {
            const value = event.currentTarget.value;
            if (value) {
                if (!Number.isNaN(Number.parseFloat(value)) || value === '-' || value.startsWith(',') || value.startsWith('-,'))
                    setNumber(value);
            }
            else {
                setNumber('');
            }
        }, ...rest }));
};
